
import React from "react";
import { useFormContext } from "react-hook-form";
import { Layout } from "../../../components";
import { Link } from "../../../components/Link/Link";
import { ENV } from "../../../constants/env";
import { formControls } from "../constants/forms";
import Checkbox from "../../../components/checkbox/checkbox";

export const ContactConsentCheckbox = () => {
    const { watch, setValue } = useFormContext();
    const isAForm = Number(ENV.REACT_APP_IS_A_FORM) === 1;
    return (
        <Layout align="flex-start" data-testid="ContactConsentCheckbox">
            <Checkbox
                id={formControls.contactConsent.key}
                name={formControls.contactConsent.key}
                checked={isAForm ? true : watch(formControls.contactConsent.key)}
                onChange={ev =>
                    setValue(
                        formControls.contactConsent.key,
                        ev.currentTarget.checked,
                        true
                    )
                }
            />
            <label className="text-14" htmlFor={formControls.contactConsent.key}>
                Al continuar, tus <b>Datos Personales</b> serán tratados conforme a
                nuestros <b>Términos y Condiciones</b>, revísalos{" "}
                <b>
                    <Link href="https://www.pacifico.com.pe/t%C3%A9rminos-y-condiciones-formularios-web">
                        aquí.
                    </Link>
                </b>
            </label>
        </Layout>
    );
};
